import styled from 'styled-components';
import { Row } from 'antd';

export default styled(Row)`
  .ant-form-item {
    margin-bottom: 30px !important;
    .ant-form-item-label {
      label {
        color: #000;
        font-size: 18px;
        font-weight: 500;
      }
    }
  }
  .ant-input,
  .ant-select-selection,
  .ant-input-number,
  .ant-select-dropdown-menu-item,
  .ant-select-dropdown-menu,
  .ant-select-dropdown,
  .ant-select-clear-icon,
  .ant-select-dropdown-menu-vertical {
    border: 1px solid #d9d9d9;
    &:hover,
    &:focus,
    &:active {
      border: 1px solid ${({ theme }) => theme.palette.primary};
    }
  }
  .ant-input-number,
  .ant-select {
    width: 100%;
  }
`;